import { Icon, IIconProps } from 'native-base';
import { Path } from 'react-native-svg';

export const MistIcon = ({ size = 'sm', ...props }: IIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 100 100" fill="none" {...props}>
      <Path
        d="M0 0 C13.2 0 26.4 0 40 0 C40 1.32 40 2.64 40 4 C27.13 4 14.26 4 1 4 C0.67 2.68 0.34 1.36 0 0 Z "
        fill="#48484A"
        transform="translate(31,58)"
      />
      <Path
        d="M0 0 C13.2 0 26.4 0 40 0 C40 1.32 40 2.64 40 4 C26.8 4 13.6 4 0 4 C0 2.68 0 1.36 0 0 Z "
        fill="#48484A"
        transform="translate(23,52)"
      />
      <Path
        d="M0 0 C13.2 0 26.4 0 40 0 C40 1.32 40 2.64 40 4 C27.13 4 14.26 4 1 4 C0.67 2.68 0.34 1.36 0 0 Z "
        fill="#48484A"
        transform="translate(37,46)"
      />
      <Path
        d="M0 0 C11.22 0 22.44 0 34 0 C34 0.99 34 1.98 34 3 C22.78 3 11.56 3 0 3 C0 2.01 0 1.02 0 0 Z "
        fill="#48484A"
        transform="translate(26,40)"
      />
      <Path
        d="M0 0 C8.58 0 17.16 0 26 0 C26 0.99 26 1.98 26 3 C17.42 3 8.84 3 0 3 C0 2.01 0 1.02 0 0 Z "
        fill="#48484A"
        transform="translate(37,64)"
      />
      <Path
        d="M0 0 C6.27 0 12.54 0 19 0 C19 0.99 19 1.98 19 3 C12.73 3 6.46 3 0 3 C0 2.01 0 1.02 0 0 Z "
        fill="#48484A"
        transform="translate(38,34)"
      />
    </Icon>
  );
};
